import moment from 'moment';
import { useEffect, useState } from 'react';
import { default as ReactSelect } from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, TextField } from '@mui/material';
import { Color } from '../../../assets/color';
import { DeleteSvg, EditSvg } from '../../../assets/svg';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../components/datatable/DatatableWithSearch';
import * as CommonActions from '../../../redux/actions/commonAction';
import * as AdminActions from '../../../redux/actions/adminAction';
import * as SuperadminActions from '../../../redux/actions/superadminAction';

const PartnerBankDetails = () => {
    const [mode, setMode] = useState('');
    const dispatch = useDispatch();
    const { partnerData } = useSelector(state => state?.adminReducer);
    const { partnerBankDetailData } = useSelector(state => state?.superadminReducer);
    const partnerOptions = partnerData && [...partnerData?.map(value => ({ value: value?._id, label: value?.partner_name }))]; //* Option

    const [inputFieldDetail, setInputFieldDetail] = useState({ partnerId: '', bank_name: '', account_number: '', account_holder_name: '', ifsc_code: '', branch: '' });
    const [inputFieldError, setInputFieldError] = useState({});

    const handleInputFieldDetail = (event) => setInputFieldDetail({ ...inputFieldDetail, [event?.target?.name]: event?.target?.value });  //* Handle Input Field : Data
    const handleInputFieldDetailError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value })); //* Handle Input Field : Error

    //* Handle Edit
    const handleEdit = (data) => {
        setInputFieldDetail({ ...data, id: data?._id, partnerId: data?.partnerId?._id });
        setMode('Edit');
    };

    //* Handle Reset 
    const handleReset = () => {
        setInputFieldDetail({ partnerId: '', bank_name: '', account_number: '', account_holder_name: '', ifsc_code: '', branch: '' });
        setMode('');
    };

    //! Handle Submit
    const handleSubmit = () => {
        console.log({ ...inputFieldDetail });
        const { partnerId, bank_name, account_number, account_holder_name, ifsc_code, branch } = inputFieldDetail;

        if (mode == 'Edit') {
            const payload = {
                id: inputFieldDetail?.id,
                data: { partnerId, bank_name, account_number, account_holder_name, ifsc_code, branch },
                onComplete: () => handleReset()
            }

            //! Dispatching API
            dispatch(SuperadminActions.updatePartnerBankDetail(payload));

        } else {
            const payload = {
                data: { partnerId, bank_name, account_number, account_holder_name, ifsc_code, branch },
                onComplete: () => handleReset()
            }
            console.log('Payload ::', payload);

            //! Dispatching API
            dispatch(SuperadminActions.createPartnerBankDetail(payload));
        }
    };

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: row => partnerBankDetailData?.indexOf(row) + 1, width: '80px' },
        { name: 'Partner', selector: row => row?.partnerId?.partner_name || '...' },
        { name: 'Acc.Hol.Name', selector: row => row?.account_holder_name },
        { name: 'Bank Name', selector: row => row?.bank_name },
        { name: 'Acc. Number', selector: row => <div style={{ color: row?.status ? 'green' : '' }}>{row?.account_number}</div> },
        { name: 'IFSC Code', selector: row => row?.ifsc_code },
        { name: 'Branch', selector: row => row?.branch },
        {
            name: 'Action',
            cell: row => (
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <div onClick={() => handleEdit(row)} style={{ cursor: "pointer" }}><EditSvg /></div>
                    <div onClick={() => dispatch(SuperadminActions.deletePartnerBankDetail({ id: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
                </div>
            ),
            right: 'true'
        },
    ];

    useEffect(() => {
        //! Dispatching API
        dispatch(AdminActions.getPartners({ label: 'Partner' }));
        dispatch(SuperadminActions.getPartnerBankDetails({}));
    }, []);

    return (
        <>
            <RouteHeader title={`Partner Bank Details System`} sub_title={`Manage partner bank detail system across the platform.`} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <DatatableHeading title={'Partner Selection'} sub_title={'Select a partner to manage their tokens.'} />
                    <div onClick={() => setMode('Add')} style={{ fontSize: '14.5px', fontWeight: '500', padding: '10px 20px 9px 20px', borderRadius: '20px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: "#FFF", cursor: 'pointer' }}>Select Partner</div>
                </div>

                <Grid container spacing={3} sx={{ marginTop: '20px' }}>
                    {mode && <>
                        <Grid item lg={8} md={12} sm={12} xs={12} >
                            <ReactSelect
                                options={partnerOptions}
                                value={partnerOptions?.find(option => option.value === inputFieldDetail.partnerId) || null}
                                onChange={(selectedOption) => handleInputFieldDetail({ target: { name: 'partnerId', value: selectedOption?.value } })}
                                isSearchable={true}
                                isClearable={true}
                                isDisabled={mode === 'Edit'}  // 🔒 Disable in Edit mode
                                placeholder="Search customer and select"
                                styles={{
                                    control: (base, state) => ({ ...base, minHeight: "45px", maxHeight: "150px", fontSize: "14px", overflow: "scroll" }),
                                    option: (base) => ({ ...base, fontSize: '12px', padding: '5px 10px', }),
                                    menu: (base) => ({ ...base, fontSize: '12px', zIndex: 1000 }),
                                    clearIndicator: (base) => ({ ...base, alignSelf: 'flex-start', padding: '10px 2px 0 0', cursor: 'pointer', }),
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: Color.primary,              // main focus/selected color
                                        primary25: "#E7E6FB",            // option hover background
                                        primary50: "#C5C3F7",            // selected option background
                                    }
                                })}
                                onFocus={() => handleInputFieldDetailError("customerId", null)}
                            />
                            {inputFieldError?.customerId && <div style={{ color: "#D32F2F", fontSize: "13px", padding: "5px 15px 0 12px", fontWeight: "500" }}>{inputFieldError?.customerId}</div>}
                        </Grid>

                        <Grid item lg={4} sm={12} md={12} xs={12}>
                            <TextField label="Account holder name" variant="outlined" fullWidth
                                name="account_holder_name"
                                value={inputFieldDetail?.account_holder_name}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.account_holder_name ? true : false}
                                helperText={inputFieldError.account_holder_name}
                                onFocus={() => handleInputFieldDetailError("account_holder_name", null)}
                            />
                        </Grid>

                        <Grid item lg={3} sm={12} md={12} xs={12}>
                            <TextField label="Bank name" variant="outlined" fullWidth
                                name="bank_name"
                                value={inputFieldDetail?.bank_name}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.bank_name ? true : false}
                                helperText={inputFieldError.bank_name}
                                onFocus={() => handleInputFieldDetailError("bank_name", null)}
                            />
                        </Grid>

                        <Grid item lg={3} sm={12} md={12} xs={12}>
                            <TextField label="Account number" variant="outlined" fullWidth type='number'
                                name="account_number"
                                value={inputFieldDetail?.account_number}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.account_number ? true : false}
                                helperText={inputFieldError.account_number}
                                onFocus={() => handleInputFieldDetailError("account_number", null)}
                            />
                        </Grid>

                        <Grid item lg={3} sm={12} md={12} xs={12}>
                            <TextField label="IFSC code" variant="outlined" fullWidth
                                name="ifsc_code"
                                value={inputFieldDetail?.ifsc_code}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.ifsc_code ? true : false}
                                helperText={inputFieldError.ifsc_code}
                                onFocus={() => handleInputFieldDetailError("ifsc_code", null)}
                            />
                        </Grid>

                        <Grid item lg={3} sm={12} md={12} xs={12}>
                            <TextField label="Branch" variant="outlined" fullWidth
                                name="branch"
                                value={inputFieldDetail?.branch}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.branch ? true : false}
                                helperText={inputFieldError.branch}
                                onFocus={() => handleInputFieldDetailError("branch", null)}
                            />
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item>
                                    <div onClick={handleReset} style={{ padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.white, color: Color.primary, fontSize: '14px', cursor: 'pointer' }}>Cancel</div>
                                </Grid>

                                <Grid item>
                                    <div onClick={handleSubmit} style={{ padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: Color.white, fontSize: '14px', cursor: 'pointer' }}>{mode} Details</div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </>}
                </Grid>
            </div>

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px", marginTop: '40px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <DatatableHeading title={'Partner Bank Details'} sub_title={'View all partner bank details'} />
                </div>

                <Grid container spacing={3} sx={{ marginTop: '20px' }}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={partnerBankDetailData} columns={columns} />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default PartnerBankDetails;